import * as tslib_1 from "tslib";
import { Flat } from './flat';
var DataGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DataGrid, _super);
    function DataGrid(param) {
        return _super.call(this, param) || this;
    }
    DataGrid.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "DataGrid" });
    };
    DataGrid.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return DataGrid;
}(Flat));
export { DataGrid };
//# sourceMappingURL=data_grid.js.map